function routePhotosCarouselInit(){

    $('.routePhotosCarousel').owlCarousel({
        loop: true,
        items:1,
        margin: 20,
        nav: false,
        lazyLoad: true,
        dots: true,
        startPosition: 0,
        onInitialized: function(event){
            let el = event.target;
            $(el).removeClass('hide');
        },
        responsive: {
            0: {
                //dotsEach: 10, // ограничить число точек
                items: 1
            },
            900: {
                //dotsEach: 7, // ограничить число точек
                items: 1,
                //nav: true
            }
        }
    });

}

export {routePhotosCarouselInit}